<template>
    <div>
        <div class="field has-addons">
            <slot name="left-control">
                <div
                    class="control tooltip has-cursor-pointer"
                    @click="$emit('with-time-toggle', !withTime)"
                    data-tooltip="Click to toggle between date and datetime"
                >
                    <div class="button is-static">
                        <i
                            class="fa cal-icon"
                            :class="{ 'fa-calendar' : !withTime, 'fa-clock-o' : withTime }"
                        ></i>
                    </div>
                </div>
            </slot>
            <div
                class="control is-expanded"
                @click="openCalendar"
            >
                <div
                    class="input flex-con is-grow xs-pad-lr"
                    :disabled="disabled"
                    :class="{ 'is-danger' : errors.has(this.name) }"
                >
                    <div>
                        <timestamp
                            v-if="value"
                            :value="value"
                            :is-full="withTime"
                            time-format="h:mm A"
                            display-in-utc
                        ></timestamp>
                        <span
                            v-else
                            class="no-selection has-text-grey"
                        >
                            {{label}}
                        </span>
                    </div>
                    <div
                        v-if="value"
                        @click="clear($event)"
                        class="is-narrow"
                    >
                        <a class="fa fa-times-circle-o"></a>
                    </div>
                </div>
            </div>
            <slot name="right-control">
            </slot>
        </div>
        <datetime
            class="datetime-is-hidden"
            ref="date"
            v-model="localValue"
            :type="!withTime ? 'date' : 'datetime'"
            :min-datetime="minTimeValue"
            value-zone="UTC"
            zone="UTC"
            :use12-hour="true"
        ></datetime>
    </div>
</template>

<script>
import moment from 'moment';
import {isNumber} from 'underscore';
export default {
    name : "DatePicker",
    inject : ['$validator'],
    $_veeValidate : {
        value () {
            //if required
            return this.value ? true : null;
        },
        validator : '$validator',
    },
    props : {
        value : {
            required : false,
        },
        label : {
            type : String,
            required : true,
        },
        withTime : {
            type : Boolean,
            default : false,
        },
        disabled : {
            type : Boolean,
            default : false,
        },
        minTimeNow : {
            type : Boolean,
            default : false,
        },
        minTimeTomorrow : {
            type : Boolean,
            default : false,
        },
        minTime : {
            type : Date,
        },
        name : {
            type : String,
            required : false,
        },
        required : {
            type : Boolean,
            default : false,
        },
    },
    computed : {
        localValue : {
            get () {
                if(this.value && isNumber(this.value)) {
                    return moment(this.value).toISOString(true);
                }
                return this.value;
            },
            set(localValue) {
                //the datetime component likes to set empty strings instead of null
                //so make sure we aren't emitting a change when a initial null value is passed that is then
                //immediately changed to an empty string by the date time component
                //this is important if network requests are made based on there being a changed value in the input
                //The datetime lib also likes to change the milliseconds on dates after being fed an initial value without one
                //so compare them to make sure they actually differ. Without this check some weird double fetching would happen in
                //the abstract search components when setting a default startDate/endDate before the component was even ready.
                if((!localValue && !this.value) || moment(localValue).diff(moment(this.value), 'seconds') === 0){
                    return;
                }
                this.$emit('input', localValue);
            },
        },
        minTimeValue () {
            if(this.minTime) {
                return moment(this.minTime).toISOString();
            }
            if(this.minTimeTomorrow) {
                return moment().add(1, 'day').utc().toISOString();
            }
            return this.minTimeNow ? moment().utc().toISOString() : null;
        },
    },
    methods : {
        openCalendar () {
            if(this.disabled) {
                return;
            }
            this.$refs.date.$el.children[0].click();
        },
        clear ($event) {
            if(this.disabled) {
                return;
            }
            $event.stopPropagation();
            this.localValue = null;
        },
    },
}
</script>

<style scoped>
    .field {
        margin-bottom:0 !important;
    }
    .input {
        cursor:pointer;
        padding:0 8px;
    }
    .cal-icon {
        transform:translate(0, -1px)
    }
</style>
